"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unescape = void 0;
const assertString_1 = require("./util/assertString");
function unescape(str) {
    (0, assertString_1.assertString)(str);
    return (str.replace(/&amp;/g, '&')
        .replace(/&quot;/g, '"')
        .replace(/&#x27;/g, '\'')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&#x2F;/g, '/')
        .replace(/&#x5C;/g, '\\')
        .replace(/&#96;/g, '`'));
}
exports.unescape = unescape;
